import { render, staticRenderFns } from "./VotacaoView.vue?vue&type=template&id=460c0f6d&"
import script from "./VotacaoView.vue?vue&type=script&lang=js&"
export * from "./VotacaoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports